import PIEChip from '@src/shared/components/PIEChip';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import styles from './DashboardOrderListFilter.module.scss';
import { useTranslation } from 'react-i18next';
import { Badge, Util } from 'snacks-design-system';
import { SwipeNav } from 'snacks-design-system/lib/es/components/swipe-nav';
import { useApplicationUiStore } from '@src/shared/store/ui-store/application-ui-store';
import { useDashboardUIStore } from '@src/pages/DeliveryDashboard/store/dashboardUIStore';
import { useOrderListFilterValues } from '../DashboardPostalCodeFilter/use-order-list-filter-values';
interface IDashboardOrderListFilter {
  onChanged: (filterValue: DASHBOARD_ORDER_FILTER_VALUES | undefined) => void;
  predefinedSelection: DASHBOARD_ORDER_FILTER_VALUES | undefined;
}

export enum DASHBOARD_ORDER_FILTER_VALUES {
  UNASSIGNED = 'UNASSIGNED',
  ON_THE_WAY = 'ON_THE_WAY',
  DELIVERED = 'DELIVERED',
  ALL = 'ALL',
}
export const DashboardOrderListFilter = (props: IDashboardOrderListFilter) => {
  const [selection, setSelection] = useState<DASHBOARD_ORDER_FILTER_VALUES | undefined>(
    props.predefinedSelection
  );
  const { t } = useTranslation();
  const { setAppDomElementClientHeightRef } = useApplicationUiStore();
  const { unreadNewOrder } = useDashboardUIStore();
  const filterRef = useRef<HTMLDivElement>(null);
  const { filterItems } = useOrderListFilterValues();

  useEffect(() => {
    if (filterRef.current) {
      /* Filter Element Height set it to UISTore */
      setAppDomElementClientHeightRef({
        domElementOffsetC: filterRef.current.clientHeight,
      });
    }
  }, []);

  useEffect(() => {
    props?.onChanged(selection);
  }, [selection]);

  /* if selection is not unassigne and the new order received state is not null  */
  return (
    <div id="dashboard-order-list-filter" className={styles.filterList} ref={filterRef}>
      <SwipeNav
        className={styles.filter_swipe}
        modSlideToClickedSlide={true}
        modSlidesOffsetAfter={false}
        initialSlide={0}
        activeSlide={filterItems.findIndex((a) => a.value === selection)}
      >
        {filterItems.map((filterItem, index) => (
          <Fragment key={index}>
            <Util paddingX="2px">
              <PIEChip
                qaSelector={
                  filterItem.value === DASHBOARD_ORDER_FILTER_VALUES.UNASSIGNED && unreadNewOrder
                    ? 'chip-bubble'
                    : ''
                }
                iconAsChildren={
                  filterItem.value === DASHBOARD_ORDER_FILTER_VALUES.UNASSIGNED &&
                  selection !== DASHBOARD_ORDER_FILTER_VALUES.UNASSIGNED &&
                  unreadNewOrder ? (
                    <Badge
                      qaSelector="bubble-on-chip"
                      mode="secondary"
                      title={`you have ${unreadNewOrder.newOrderAmount} unassigned orders`}
                    >
                      {unreadNewOrder.newOrderAmount}
                    </Badge>
                  ) : null
                }
                className={styles.filter_item}
                isSelected={filterItem.value === selection}
                onClick={() => setSelection(filterItem.value)}
              >
                {selection !== DASHBOARD_ORDER_FILTER_VALUES.UNASSIGNED &&
                unreadNewOrder &&
                index === 0
                  ? t('order.status_NEW_ORDER_RECEIVED')
                  : filterItem.title}
              </PIEChip>
            </Util>
          </Fragment>
        ))}
      </SwipeNav>
    </div>
  );
};

export default DashboardOrderListFilter;
